<template>
  <div class="bbp-reminder">
    <div
      class="bbp-reminder__icon"
      v-html="notificationIcon()"
      @click.stop="onOpenPanel"
    />
    <template v-if="remindersList.length">
      <div
        v-if="checkReadUser"
        class="bbp-reminder__pointer"
        :style="pointerStyle"
      />
      <div
        class="bbp-reminder__counter"
        :style="counterStyle"
      >
        {{remindersList.length}}
      </div>
    </template>
    <transition name="slide-sidebar">
      <BBPReminderPanel
        v-if="isShowPanel === row._id"
        :remindersList.sync="remindersList"
        :row="row"
        :column="column"
      />
    </transition>
  </div>
</template>

<script>
import { NOTIFICATION_ICON } from '@/constants/icons'
import { USER_NOTIFICATION } from '@/constants/userNotification'
import BBPReminderPanel from '@/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanel'
import sortByDate from '@/mixin/sortByDate'

export default {
  name: 'BBPReminder',
  components: { BBPReminderPanel },
  props: ['row', 'column'],
  mixins: [sortByDate],
  data: () => ({
    notificationIcon: NOTIFICATION_ICON,
    isRead: false,
    remindersList: []
  }),
  sockets: {
    reminders (reminder) {
      const { id } = this.userInfo
      const { user, project = [], targetUser = [] } = reminder
      const [currentProject = {}] = project
      const [currentUser] = user
      if (currentProject._id !== this.row._id) return
      if (currentUser.id === id) this.addReminder(reminder)
      const currentItem = targetUser.find((el) => el._id === id)
      if (currentItem && (currentItem._id !== currentUser.id)) this.addReminder(reminder)
    },
    usersnotification (notification) {
      const { eventNotification } = notification
      if (eventNotification === USER_NOTIFICATION.USER_NOTIFICATION_REMINDER) {
        const { id } = this.userInfo
        const { user, eventId, targetUser = [] } = notification
        const [userTarget] = targetUser
        if (user === id) this.updateReminderList(eventId)
        if (userTarget === id) this.updateReminderList(eventId)
      }
    }
  },
  computed: {
    isShowPanel: {
      get () {
        return this.$store.getters.isShowPanel
      },
      set (data) {
        this.$store.dispatch('setShowPanel', data)
      }
    },
    userInfo () {
      return this.$store.getters.userInfo || {}
    },
    reminders () {
      const { prop } = this.column
      return this.row[prop] || []
    },
    pointerStyle () {
      const { pointerStyle } = this.column
      return pointerStyle
    },
    isNoClick () {
      const { isNoClick = false } = this.column
      return isNoClick
    },
    counterStyle () {
      const { counterStyle } = this.column
      return counterStyle
    },
    checkReadUser () {
      const { id = '5f8097e4e06d0800124c7a5d' } = this.userInfo
      const ids = this.remindersList.map(el => {
        const { readUsers = [] } = el
        return readUsers.length ? readUsers : [-1]
      })
      const isRead = ids.some((el) => {
        const item = el.find((item) => item !== id)
        if (typeof item === 'string') {
          return el.findIndex((item) => item === id) !== 1
        } else {
          return item
        }
      })
      return isRead
    }
  },
  methods: {
    onOpenPanel () {
      if (this.isNoClick) return
      const { _id } = this.row
      this.isShowPanel = _id
    },
    updateReminderList (eventId) {
      const index = this.remindersList.findIndex((el) => el._id === eventId)
      if (index === -1) return
      this.remindersList.splice(index, 1)
    },
    addReminder (reminder) {
      this.remindersList.push(reminder)
      this.remindersList = this.sortByDate(this.remindersList, 'nextReminder')
    }
  },
  beforeMount () {
    if (this.row.id) this.row._id = this.row.id
    this.remindersList = this.reminders
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bbp-reminder {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    &__icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      cursor: pointer;
      transition: 0.15s;
    }

    &__pointer {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      border: 1px solid $color-white;
      position: absolute;
      top: 2px;
      left: 30px;
      background: $color-pomegranate;
    }

    &__counter {
      position: absolute;
      top: -4px;
      left: 38px;
      font-size: 10px;
      line-height: 14px;
      font-weight: 600;
      color: $color-denim;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPReminder/BBPReminder.vue